<button (click)=toMainConent() class="skip-to-content" tabindex="0" aria-label="Jump to main content">Skip to
  content</button>
<header class="primary-header">
  <div class="container">
    <a class="logo" routerLink="/" aria-label="Catering homepage">
      <img src="/assets/images/catering-logo.svg" alt="Catering Logo" />
    </a>
    <app-menu></app-menu>
  </div>
</header>
<main id="main-content">
  <router-outlet></router-outlet>
  <!--<app-mealset [mealSet]="mealSet" *ngFor="let mealSet of mealSets;"></app-mealset>-->
</main>
<footer class="primary-footer">
  <div class="policies">
    <nav class="container" aria-label="Policy Navigation">
      <a routerLink="policies" fragment="off-site-policy">Offsite Policy</a>
      <a routerLink="policies" fragment="on-premise-policy">On Premise Policy</a>
      <a routerLink="policies" fragment="student-policy">Student Policy</a>
    </nav>
  </div>
  <div class="container">
    <a href="https://dining.umich.edu" aria-label="Visit the Michigan Dining Website">
      <img src="/assets/images/dining-logo.svg" alt="Dining Logo" />
    </a>
    <div>
      <p>M|Catering<br />
        <a routerLink="/contact">Contact Us</a><br />
        <a href="tel:17347642000">(734) 764-2000</a>
      </p>
      <p>Copyright © {{currentYearLong()}} The Regents of the University of Michigan</p>
    </div>
  </div>
</footer>